import { Exception } from './Exception';
export class CustomerExistsException extends Exception {
  constructor(message = 'Customer with this e-mail already exists.') {
    super(message);
    this.name = 'CustomerExistsException';
  }
}
